import React, { useContext, useEffect } from 'react';

import Conversa from './Conversa';
import Filtro from './Filtro';
import Paginacao from './Paginacao';
import useStyle from './style';

import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';

export default function Conversas() {
  const classes = useStyle();
  const { conversas, irParaConversa, termoPesquisa } =
    useContext(MensagensContext);

  useEffect(() => {
    if (termoPesquisa && termoPesquisa.length > 0) {
      irParaConversa('');
    }
  }, [termoPesquisa, irParaConversa]);

  return (
    <div className={classes.root}>
      <Filtro
        pendentes={conversas.countMensagensPendentes}
        respondidos={conversas.countMensagensRespondidas}
        emResposta={conversas.countMensagensEmResposta}
      />
      <div className={classes.list}>
        <div className={classes.listContent}>
          {conversas.elements.map((conversa) => (
            <Conversa key={conversa.cpfUsuario} {...conversa} />
          ))}
        </div>
        <Paginacao />
      </div>
    </div>
  );
}
